<template>
  <TodoMVC />
</template>

<script>
import TodoMVC from "./TodoMVC.vue";
import { mapActions } from "vuex";

export default {
  components: {
    TodoMVC
  },
  methods: {
    ...mapActions("todoList", ["setVisibility"])
  },
  mounted() {
    // handle routing
    const vm = this;
    function onHashChange() {
      const visibility = window.location.hash.replace(/#\/?/, "");
      if (["all", "completed", "active"].includes(visibility)) {
        vm.setVisibility(visibility);
      } else {
        window.location.hash = "";
        vm.setVisibility("all");
      }
    }

    window.addEventListener("hashchange", onHashChange);
    onHashChange();
  }
};
</script>
